import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const TRON_TOKEN_TICKERS = [Ticker.USDT]

export type TronTokenTicker = IterableElement<typeof TRON_TOKEN_TICKERS>
